import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import * as Sentry from "@sentry/react";

import { Error } from '../../screens/Error/index';

import './errorBoundary.css';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null
    }
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error });
    Sentry.captureException(error, { extra: errorInfo });
  }

  render() {
    if (this.state.error) {
      return (
        <Error {...this.props}></Error>
      );
    } else {
      return this.props.children;
    }
  }
}

export default withRouter(ErrorBoundary)


// WEBPACK FOOTER //
// ./src/components/ErrorBoundary/ErrorBoundary.js